// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2mnsz","head":"Table_head__3om2O","col":"Table_col__gk_HB"};